/**
 * Greptile-style chrome applied to every portal route. The sidebar lists
 * the navigation groups; the top tabs strip identifies the current
 * section; the page body sits to the right of the rail.
 *
 * Each route's page element is wrapped in this layout so the chrome
 * stays consistent. Disabled sidebar entries remain visible but
 * non-interactive (greyscale + `aria-disabled`) so the affordance is
 * obvious without producing dead-link confusion.
 */
import type { ReactNode } from 'react';
import { HeaderIcons } from './HeaderIcons.js';
import { Sidebar } from './Sidebar.js';
import { TopTabs } from './TopTabs.js';

interface AppLayoutProps {
  children: ReactNode;
  /** Optional title rendered in the content header row. If absent,
   *  the header row is omitted (preserves the legacy compact layout). */
  title?: string;
}

export function AppLayout({ children, title }: AppLayoutProps) {
  return (
    <div className="feluda-app">
      <Sidebar />
      <div className="feluda-app-main">
        <TopTabs />
        <div className="feluda-app-content">
          {title !== undefined && (
            <div className="feluda-app-content-header">
              <h1 className="feluda-app-content-title">{title}</h1>
              <HeaderIcons />
            </div>
          )}
          <div className="feluda-app-content-body">{children}</div>
        </div>
      </div>
    </div>
  );
}
